import { Injectable } from '@angular/core';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { User } from '../model/users.model';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Url } from '../model/users.model';
import { Role } from '../model/role.model';
import { environment } from './../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ComponentsSettingsService {
    
    private headers = new Headers({ 'Content-Type': 'application/json' });
    
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    constructor(public localStorageService: LocalStorageService, public http: HttpClient) {
        this.getLoginRole();
    }
    @LocalStorage() components: any;

    private user: User;
    private roles: Role[];
    private url: Url;
    private component_modules: any[];

    private sar: number;
    public get sar_id(){
        return this.sar;
    }

    private ar: number;
    public get ar_id(){
        return this.ar;
    }

    private car: number;
    public get car_id(){
        return this.car;
    }

    private _access_role : number;
    public get access_role(){
        return this._access_role;
    }

    private _access_role_name : string;
    public get access_role_name(){
        return this._access_role_name;
    }

    public set access_role(rvalue: number){
        this._access_role = rvalue;
    }

    public getComponentAccess(component:string):boolean{
        this.getLoginRole();
        //to do will get settings on the db
        return true;    
    }

    public getTmsComponents(): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getTmsComponents', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    public getComponentSettings(role_id): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getComponentSettings/' + role_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    public updateComponentsSettings(components: any): Observable<any> {
        return this.http.post(this.url.rest + '/tms/updateComponentsSettings', components , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    public getTMSComponentsForMenuRoutes(role_id): Observable<any[]> { 
		return this.http.get<any[]>(this.url.rest + '/tms/getTMSComponentsForMenuRoutes/' + role_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
    }

    public async getLoginRole(){
        this.url = this.localStorageService.get('url');

        //set user role id
        this.user = this.localStorageService.get('user');
        this.roles = this.localStorageService.get('roles');
        this._access_role = 1;//default admin;

        //get superadmin and admin role id
        if(this.roles != null){
            let role_record;
            role_record = this.roles.filter(x=>{return x.name == 'Super Administrator'});
            if(role_record.length>0){
                this.sar = parseInt(role_record[0]['id']);
            };            

            role_record = this.roles.filter(x=>{return x.name == 'Administrator'});
            if(role_record.length>0){
                this.ar = parseInt(role_record[0]['id']);
            };

            role_record = this.roles.filter(x=>{return x.name == 'Compliance Administrator'});
            if(role_record){
                this.car = parseInt(role_record[0]['id']);
            };
            
        }
        
        if(this.user != null){
            this._access_role = parseInt(this.user['role_id']);
            
            switch(this._access_role){
                case this.sar: {this._access_role_name = 'Super Administrator';}break;
                case this.ar: {this._access_role_name = 'Administrator'}break;
                case this.car: {this._access_role_name = 'Compliance Administrator'}break;
            }
        }
    }

    public isComponentEnabled(component_name){
        let tms_components = this.localStorageService.get('components');
        if (tms_components){
            let exists = tms_components.filter(c=>{ return c == component_name});
            if(exists?.length > 0){
                return true;
            }else{
                return false;
            }
        }else{
            return false;
        }
    }

    hasSubMenu(module_name){
        var has_sub_menu = false;
        let tms_components = this.localStorageService.get('components');
        this.component_modules = this.localStorageService.get('component_modules');

        let filtered_modules = this.component_modules;
        if(filtered_modules){
            filtered_modules = filtered_modules.filter(c=>{return c.root_module == module_name});
            filtered_modules.forEach(cm=>{
                let is_present = tms_components.filter(tc=> {return tc == cm.name});
                if(is_present.length > 0){
                    has_sub_menu = true;
                    return has_sub_menu;
                }
            });
        }
        
        return has_sub_menu;
    }

    modulesHasSubMenu(module_names){
        var has_sub_menu = false;
        let tms_components = this.localStorageService.get('components');
        this.component_modules = this.localStorageService.get('component_modules');
        
        module_names.forEach(module_name =>{
            let filtered_modules = this.component_modules;
            if(filtered_modules){
                filtered_modules = filtered_modules.filter(c=>{return c.root_module == module_name});
                filtered_modules.forEach(cm=>{
                    let is_present = tms_components.filter(tc=> {return tc == cm.name});
                    if(is_present.length > 0){
                        has_sub_menu = true;
                        return has_sub_menu;
                    }
                });
            }
        });

        return has_sub_menu;
    }

    hasSubMenuSettings(){
        var has_sub_menu = false;
        let tms_components = this.localStorageService.get('components');
        this.component_modules = this.localStorageService.get('component_modules');

        let filtered_modules = this.component_modules;
        let filtered_enabled_components = tms_components;
        
        if(filtered_modules){
            let is_checklist_or_inspection = filtered_enabled_components.filter(tc=> {return tc == 'Weekly Inspection' || tc == 'Checklists'});
            if(is_checklist_or_inspection.length >0){
                var has_checklist_submenu = this.hasSubMenu('Checklists');
                var has_inspection_submenu = this.hasSubMenu('Weekly Inspection');
                
                if(has_checklist_submenu || has_inspection_submenu){
                    has_sub_menu= true;
                    return has_sub_menu;
                }
            };

            filtered_modules = filtered_modules.filter(c=>{return c.root_module == 'Settings'});
            filtered_modules.forEach(cm=>{
                let is_present = tms_components.filter(tc=> {return (tc == cm.name) && (tc!='Checklists') && (tc!='Weekly Inspection')});
                if(is_present.length > 0){
                    has_sub_menu= true;
                    return has_sub_menu;
                }
            });
        }
        
        return has_sub_menu;
    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}